import * as CookieConsent from 'vanilla-cookieconsent';

import config from './config';
import CookieConsentHandler from './handler';
import { determineGeoLocation } from './helpers';

export default async function init() {
  const cookieConsentHandler = new CookieConsentHandler(config, CookieConsent);

  config.onFirstConsent = cookieConsentHandler.onFirstConsent;
  config.onConsent = cookieConsentHandler.onConsent;
  config.onChange = cookieConsentHandler.onChange;
  config.onModalShow = cookieConsentHandler.onModalShow;
  config.onModalHide = cookieConsentHandler.onModalHide;

  const geo = await determineGeoLocation();

  cookieConsentHandler.setGeo(geo);
  CookieConsent.run(config);
}

export * from './utils';
